<template>
  <div class="ls-tos">
    <h3>{{ t('termsOfService.label') }}</h3>
    <br />
    <p>{{ t('termsOfService.lawnstarter.lastUpdated') }}</p>
    <p>
      {{ t('termsOfService.lawnstarter.header.pleaseReadTerms') }}
      <a href="https://lawnstarter.com" target="_blank" rel="noopener noreferrer">lawnstarter.com</a
      >{{ t('termsOfService.lawnstarter.header.applicationsProvided') }}
    </p>
    <br />
    <p>
      {{ t('termsOfService.lawnstarter.additionalTerms.termsCanBeFoundAt') }}
      <a href="https://lawnstarter.com/eula" target="_blank" rel="noopener noreferrer"
        >lawnstarter.com/eula</a
      >
      {{ t('termsOfService.lawnstarter.additionalTerms.and') }}
      <a
        href="https://lawnstarter.com/lawn-care-services-agreement"
        target="_blank"
        rel="noopener noreferrer"
      >
        lawnstarter.com/lawn-care-services-agreement</a
      >.
    </p>
    <br />
    <p>
      {{ t('termsOfService.lawnstarter.ifYouHaveQuestions')
      }}<a href="mailto:team@lawnstarter.com">team@lawnstarter.com</a>.
    </p>
    <br />
    <h3>1. {{ t('termsOfService.lawnstarter.body.companyIsPlatform.label') }}</h3>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.companyIsPlatform.companyActAsPlatform') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.companyIsPlatform.companyCannotGuarantee') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.companyIsPlatform.youAgree') }}</p>
    <br />
    <h3>2. {{ t('termsOfService.lawnstarter.body.membershipEligibility.label') }}</h3>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.membershipEligibility.servicesAreAvailable') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.membershipEligibility.individualsUnder') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.membershipEligibility.youAgree') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.membershipEligibility.inAddition') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.membershipEligibility.keepPasswordSecure') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.membershipEligibility.keepInfoUpToDate') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.membershipEligibility.servicesAreUnavailable') }}</p>
    <br />
    <h3>3. {{ t('termsOfService.lawnstarter.body.prohibitedActivities.label') }}</h3>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.prohibitedActivities.youAreResponsible') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.prohibitedActivities.companyWillNot.label') }}</p>
    <ul>
      <li>
        {{ t('termsOfService.lawnstarter.body.prohibitedActivities.companyWillNot.beFalse') }}
      </li>
      <li>
        {{
          t(
            'termsOfService.lawnstarter.body.prohibitedActivities.companyWillNot.infringeUponThirdParty'
          )
        }}
      </li>
      <li>
        {{
          t(
            'termsOfService.lawnstarter.body.prohibitedActivities.companyWillNot.violateThisAgreement'
          )
        }}
      </li>
      <li>
        {{ t('termsOfService.lawnstarter.body.prohibitedActivities.companyWillNot.beDefamatory') }}
      </li>
      <li>
        {{ t('termsOfService.lawnstarter.body.prohibitedActivities.companyWillNot.takeAnyAction') }}
      </li>
      <li>
        {{ t('termsOfService.lawnstarter.body.prohibitedActivities.companyWillNot.beObscene') }}
      </li>
      <li>
        {{
          t('termsOfService.lawnstarter.body.prohibitedActivities.companyWillNot.containOrTransmit')
        }}
      </li>
    </ul>
    <br />
    <h3>4. {{ t('termsOfService.lawnstarter.body.licenseGrant.label') }}</h3>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.licenseGrant.companyGrants') }}</p>
    <br />
    <h3>5. {{ t('termsOfService.lawnstarter.body.paymentTerms.label') }}</h3>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.paymentTerms.anyFees') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.paymentTerms.pleaseNote') }}</p>
    <br />
    <h3>6. {{ t('termsOfService.lawnstarter.body.intellectualProperty.label') }}</h3>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.intellectualProperty.companyAlone') }}</p>
    <br />
    <h3>7. {{ t('termsOfService.lawnstarter.body.personalInfo.label') }}</h3>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.personalInfo.asPartOfService') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.personalInfo.byUsingService') }}</p>
    <br />
    <h3>8. {{ t('termsOfService.lawnstarter.body.mobileMessageService.label') }}</h3>
    <br />
    <p>
      {{ t('termsOfService.lawnstarter.body.mobileMessageService.theCompanyMobileMessageService') }}
    </p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.mobileMessageService.byConsenting') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.mobileMessageService.weDoNotCharge') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.mobileMessageService.youMay') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.mobileMessageService.ifYou') }}</p>
    <br />
    <p>
      {{ t('termsOfService.lawnstarter.body.mobileMessageService.forMobileService')
      }}<a href="mailto:team@lawnstarter.com">team@lawnstarter.com</a>.
    </p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.mobileMessageService.weMayChange') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.mobileMessageService.theWireless') }}</p>
    <br />
    <h3>9. {{ t('termsOfService.lawnstarter.body.feedback.label') }}</h3>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.feedback.companyConsidersSuggestion') }}</p>
    <br />
    <h3>10. {{ t('termsOfService.lawnstarter.body.informationControl.label') }}</h3>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.informationControl.companyDoesNotControl') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.informationControl.companyIsNotResponsible') }}</p>
    <br />
    <h3>11. {{ t('termsOfService.lawnstarter.body.accessInterference.label') }}</h3>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.accessInterference.companyMayContain') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.accessInterference.additionally.label') }}</p>
    <ul>
      <li>
        {{ t('termsOfService.lawnstarter.body.accessInterference.additionally.takeAnyAction') }}
      </li>
      <li>
        {{ t('termsOfService.lawnstarter.body.accessInterference.additionally.copyReproduce') }}
      </li>
      <li>
        {{
          t('termsOfService.lawnstarter.body.accessInterference.additionally.interfereOrAttempt')
        }}
      </li>
      <li>
        {{ t('termsOfService.lawnstarter.body.accessInterference.additionally.bypassCompany') }}
      </li>
    </ul>
    <br />
    <h3>12. {{ t('termsOfService.lawnstarter.body.breach.label') }}</h3>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.breach.withoutLimiting') }}</p>
    <br />
    <h3>13. {{ t('termsOfService.lawnstarter.body.privacy.label') }}</h3>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.privacy.exceptAsProvided') }}</p>
    <br />
    <h3>14. {{ t('termsOfService.lawnstarter.body.noWarranty.label') }}</h3>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.noWarranty.companyWarranty') }}</p>
    <br />
    <h3>15. {{ t('termsOfService.lawnstarter.body.limitationLiability.label') }}</h3>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.limitationLiability.inNoEventCompanyWill') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.limitationLiability.companysLiability') }}</p>
    <br />
    <h3>16. {{ t('termsOfService.lawnstarter.body.indemnity.label') }}</h3>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.indemnity.youAgree') }}</p>
    <br />
    <h3>17. {{ t('termsOfService.lawnstarter.body.noGuarantee.label') }}</h3>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.noGuarantee.companyDoesNotGuarantee') }}</p>
    <br />
    <h3>18. {{ t('termsOfService.lawnstarter.body.disputeResolution.label') }}</h3>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.disputeResolution.companyIsNotResponsible') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.disputeResolution.forDispute.label') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.disputeResolution.forDispute.youAgree') }}</p>
    <br />
    <p>
      {{
        t(
          'termsOfService.lawnstarter.body.disputeResolution.forDispute.arbitrationAdministeredByAaa'
        )
      }}
    </p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.disputeResolution.forDispute.partyWhoDesires') }}</p>
    <br />
    <p>
      {{ t('termsOfService.lawnstarter.body.disputeResolution.forDispute.unlessYouAndCompany') }}
    </p>
    <br />
    <p>
      {{ t('termsOfService.lawnstarter.body.disputeResolution.forDispute.arbitratorWillRender') }}
    </p>
    <br />
    <p>
      {{ t('termsOfService.lawnstarter.body.disputeResolution.forDispute.yourResponsibility') }}
    </p>
    <br />
    <p>
      {{
        t('termsOfService.lawnstarter.body.disputeResolution.forDispute.notwithstandingProvisions')
      }}
    </p>
    <br />
    <h3>19. {{ t('termsOfService.lawnstarter.body.miscellaneous.label') }}</h3>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.miscellaneous.ifAnyProvision') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.miscellaneous.unlessOtherwise') }}</p>
    <br />
    <p>{{ t('termsOfService.lawnstarter.body.miscellaneous.companyReserves') }}</p>
    <br />
  </div>
</template>
<script>
export default {
  name: 'LsTosText',
};
</script>
<style lang="scss" scoped>
h3 {
  color: $gray-primary;

  &:first-of-type {
    font-weight: bold;
  }

  &:not(:first-of-type) {
    margin-top: 20px;
  }
}

p,
span,
ol,
a,
h3,
ul {
  font-size: $size-6;
}

p:first-of-type {
  margin-bottom: 10px;
}

ul {
  list-style-type: disc;
  margin-top: 10px;
  padding-left: 25px;
}

.themed-app {
  ::-webkit-scrollbar-thumb {
    background-color: $theme-color-gray-dark;
  }
  h3 {
    color: $theme-color-gray-darker;
  }
  p,
  span,
  ol,
  a,
  h3,
  ul {
    font-size: $theme-txt-body-sm;
  }
}
</style>
